<template><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7904_11005)">
<path d="M17.1833 7.04183C16.3083 3.19183 12.95 1.4585 10 1.4585C10 1.4585 10 1.4585 9.99167 1.4585C7.05 1.4585 3.68334 3.1835 2.80834 7.0335C1.83334 11.3335 4.46667 14.9752 6.85 17.2668C7.73334 18.1168 8.86667 18.5418 10 18.5418C11.1333 18.5418 12.2667 18.1168 13.1417 17.2668C15.525 14.9752 18.1583 11.3418 17.1833 7.04183ZM10 11.2168C8.55 11.2168 7.375 10.0418 7.375 8.59183C7.375 7.14183 8.55 5.96683 10 5.96683C11.45 5.96683 12.625 7.14183 12.625 8.59183C12.625 10.0418 11.45 11.2168 10 11.2168Z" fill="#ADADAD"/>
</g>
<defs>
<clipPath id="clip0_7904_11005">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
</template>